import React from 'react';
import DynamicFormViewer from '../../Components/FormData/DynamicFormViewer';
import {
  getAllCalmYourEczemaNaturally,
  deleteCalmYourEczemaNaturally,
  updateCalmYourEczemaNaturallyById,
} from '../../Redux/Store/API/FormsData/CalmYourEczemaNaturally';

export default function CalmEczemaNaturallyFormData() {
  const headers = [
    { key: 'name', label: 'Name' },
    { key: 'mobileNo', label: 'Mobile No' },
    { key: 'ailment', label: 'Ailment' },
    { key: 'query', label: 'Query / Description' },
    { key: 'sourcePage', label: 'Source Page', render: (v) => v || '—' },
  ];

  return (
    <DynamicFormViewer
      title="Calm Your Ailment Naturally"
      headers={headers}
      fetchAction={getAllCalmYourEczemaNaturally}
      deleteAction={deleteCalmYourEczemaNaturally}
      updateAction={updateCalmYourEczemaNaturallyById}
      stateSliceName="calmYourEczemaNaturally"
      dataKey="getallCalmYourEczemaNaturally"
    />
  );
}
